import { DynamicStandaloneArticleFooter } from '@/components/ArticleFooter';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorArticleFooter: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneArticleFooter tags={data.tags} options={data.options} {...withDebugMetadata({ type, meta })} />
  );
};

export default LabradorArticleFooter;
